/* ============================================================
   BRAT & JUDY LANDING PAGE
   File: assets/brat-and-judy.js
   ============================================================ */

(function() {
  'use strict';

  // ===== FLOATING HEARTS =====
  function initHeartField() {
    const heartField = document.getElementById('bjHeartField');
    if (!heartField) return;

    const heartShapes = ['♥', '♡', '✦', '♥'];
    const count = window.innerWidth < 768 ? 10 : 18;

    for (let i = 0; i < count; i++) {
      const heart = document.createElement('div');
      heart.className = 'floating-heart';
      heart.innerHTML = heartShapes[Math.floor(Math.random() * heartShapes.length)];
      heart.style.left = Math.random() * 100 + '%';
      heart.style.fontSize = (Math.random() * 28 + 14) + 'px';
      heart.style.animationDuration = (Math.random() * 12 + 10) + 's';
      heart.style.animationDelay = (Math.random() * 8) + 's';
      heartField.appendChild(heart);
    }
  }

  // ===== EMAIL GATE UNLOCK =====
  // Persists unlock state in localStorage so returning visitors
  // who already submitted email don't see the gate again.
  function checkExistingUnlock() {
    if (localStorage.getItem('bj_unlocked') === 'true') {
      unlockEpisodes(true);
    }
  }

  function unlockEpisodes(skipScroll) {
    // Mark the hero as unlocked so CSS can compact the padding
    const heroSection = document.querySelector('.bj-hero');
    if (heroSection) heroSection.classList.add('is-unlocked');

    const cards = document.querySelectorAll('.bj-page .episode-card');
    cards.forEach((card, i) => {
      setTimeout(() => {
        card.classList.remove('locked');
        replaceCardWithVideo(card);
      }, skipScroll ? 0 : i * 150);
    });

    const gate = document.getElementById('bjGate');
    if (gate && !skipScroll) {
      // Fresh unlock — show the celebratory confirmation
      gate.innerHTML = `
        <div class="gate-lock" style="font-size:42px;">♥</div>
        <h2 class="gate-headline">You're <em>in.</em></h2>
        <p class="gate-copy">All episodes unlocked below. Check your inbox — new drops headed your way every Mon, Wed & Fri.</p>
        <a href="#bj-episodes" class="fb-btn" style="display:inline-flex;">Watch Now</a>
      `;
      setTimeout(() => {
        const target = document.getElementById('bj-episodes');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }, 600);
    } else if (gate) {
      // Returning visitor — swap the gate for a slim welcome-back banner
      // instead of hiding it entirely (which would leave a big gap)
      gate.classList.add('gate-returning');
      gate.innerHTML = `
        <div class="returning-pill">
          <span class="returning-heart">♥</span>
          <span class="returning-text">Welcome back, Krewe.</span>
          <a href="#bj-episodes" class="returning-link">Jump to episodes →</a>
        </div>
      `;
    }

    localStorage.setItem('bj_unlocked', 'true');
  }

  // ===== FULLSCREEN HELPER =====
  // Fullscreens a wrapper div instead of the video element directly.
  // This lets our CSS control video sizing (object-fit:contain) so
  // portrait videos letterbox properly instead of getting cropped.
  function toggleWrapperFullscreen(wrap) {
    const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (fsEl) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }
    const requestFs = wrap.requestFullscreen || wrap.webkitRequestFullscreen;
    if (requestFs) {
      requestFs.call(wrap).catch(function(err) {
        console.warn('Fullscreen request denied:', err);
      });
    }
  }

  // ===== CUSTOM VIDEO PLAYER =====
  // Wires up branded controls: play/pause overlay, scrubber, time display,
  // mute, fullscreen, and auto-hiding controls bar on playback.
  function bindCustomPlayer(wrap, video) {
    if (!wrap || !video) return;

    const playOverlay = wrap.querySelector('.bj-play-overlay');
    const playBtn = wrap.querySelector('.bj-play-btn');
    const muteBtn = wrap.querySelector('.bj-mute-btn');
    const fsBtn = wrap.querySelector('.bj-fs-btn');
    const scrubberInput = wrap.querySelector('.bj-scrubber-input');
    const progressBar = wrap.querySelector('.bj-scrubber-progress');
    const bufferedBar = wrap.querySelector('.bj-scrubber-buffered');
    const timeCurrent = wrap.querySelector('.bj-time-current');
    const timeTotal = wrap.querySelector('.bj-time-total');
    const loader = wrap.querySelector('.bj-loader');

    let hideControlsTimer = null;
    let isScrubbing = false;

    function formatTime(secs) {
      if (!isFinite(secs)) return '0:00';
      const m = Math.floor(secs / 60);
      const s = Math.floor(secs % 60);
      return m + ':' + (s < 10 ? '0' + s : s);
    }

    function togglePlay() {
      if (video.paused) {
        video.play().catch(function(err) { console.warn('Play denied:', err); });
      } else {
        video.pause();
      }
    }

    function showControls() {
      wrap.classList.add('controls-visible');
      clearTimeout(hideControlsTimer);
      if (!video.paused) {
        hideControlsTimer = setTimeout(function() {
          wrap.classList.remove('controls-visible');
        }, 3000);
      }
    }

    function hideControlsImmediate() {
      wrap.classList.remove('controls-visible');
      clearTimeout(hideControlsTimer);
    }

    // ===== Event bindings =====

    // Center play overlay
    playOverlay.addEventListener('click', function(e) {
      e.stopPropagation();
      togglePlay();
    });

    // Click anywhere on the video body to toggle play/pause
    video.addEventListener('click', function(e) {
      togglePlay();
    });

    // Bottom controls play/pause
    playBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      togglePlay();
    });

    // Mute toggle
    muteBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      video.muted = !video.muted;
      wrap.classList.toggle('is-muted', video.muted);
    });

    // Fullscreen
    fsBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      toggleWrapperFullscreen(wrap);
    });

    // Scrubber input — seek video
    scrubberInput.addEventListener('input', function() {
      isScrubbing = true;
      const pct = parseFloat(scrubberInput.value);
      progressBar.style.width = pct + '%';
      if (video.duration) {
        timeCurrent.textContent = formatTime((pct / 100) * video.duration);
      }
    });
    scrubberInput.addEventListener('change', function() {
      const pct = parseFloat(scrubberInput.value);
      if (video.duration) {
        video.currentTime = (pct / 100) * video.duration;
      }
      isScrubbing = false;
    });

    // Video state events
    video.addEventListener('loadedmetadata', function() {
      timeTotal.textContent = formatTime(video.duration);
    });

    video.addEventListener('timeupdate', function() {
      if (isScrubbing) return;
      if (video.duration) {
        const pct = (video.currentTime / video.duration) * 100;
        scrubberInput.value = pct;
        progressBar.style.width = pct + '%';
        timeCurrent.textContent = formatTime(video.currentTime);
      }
    });

    video.addEventListener('progress', function() {
      if (video.buffered.length && video.duration) {
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        const pct = (bufferedEnd / video.duration) * 100;
        bufferedBar.style.width = pct + '%';
      }
    });

    video.addEventListener('play', function() {
      wrap.classList.add('is-playing');
      wrap.classList.remove('is-paused');
      showControls();
    });

    video.addEventListener('pause', function() {
      wrap.classList.remove('is-playing');
      wrap.classList.add('is-paused');
      showControls();
      clearTimeout(hideControlsTimer);
      wrap.classList.add('controls-visible');
    });

    video.addEventListener('ended', function() {
      wrap.classList.remove('is-playing');
      wrap.classList.add('is-paused');
      wrap.classList.add('controls-visible');
    });

    video.addEventListener('waiting', function() {
      wrap.classList.add('is-loading');
    });

    video.addEventListener('playing', function() {
      wrap.classList.remove('is-loading');
    });

    video.addEventListener('canplay', function() {
      wrap.classList.remove('is-loading');
    });

    // Mouse activity reveals controls
    wrap.addEventListener('mousemove', showControls);
    wrap.addEventListener('touchstart', showControls);

    // Sync fullscreen state for icon swap
    function syncFsState() {
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      wrap.classList.toggle('is-fullscreen', fsEl === wrap);
    }
    document.addEventListener('fullscreenchange', syncFsState);
    document.addEventListener('webkitfullscreenchange', syncFsState);

    // Initial state: paused, controls visible, muted state synced
    wrap.classList.add('is-paused');
    wrap.classList.add('controls-visible');
    wrap.classList.toggle('is-muted', video.muted);
  }

  // ===== FB VIDEO MODAL =====
  // Opens FB video in a fixed-size portrait lightbox. Fixed dimensions
  // render FB's plugin more reliably than responsive sizing.
  function openFBModal(fbUrl) {
    // Close any existing modal
    const existing = document.getElementById('bjFBModal');
    if (existing) existing.remove();

    // Normalize URL — add trailing slash to Reels
    let embedUrl = fbUrl.trim();
    if (/facebook\.com\/reel\/\d+$/i.test(embedUrl)) {
      embedUrl = embedUrl + '/';
    }
    const encodedUrl = encodeURIComponent(embedUrl);
    // Fixed pixel dimensions in the URL — this is what FB's own embed
    // generator uses, and it renders far more reliably than percentages
    const iframeSrc = 'https://www.facebook.com/plugins/video.php' +
      '?height=700&href=' + encodedUrl +
      '&show_text=false&width=400&t=0&autoplay=true';

    const modal = document.createElement('div');
    modal.id = 'bjFBModal';
    modal.className = 'bj-fb-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = `
      <div class="bj-fb-modal-backdrop"></div>
      <div class="bj-fb-modal-inner">
        <button type="button" class="bj-fb-modal-close" aria-label="Close video">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="bj-fb-modal-frame">
          <iframe
            src="${iframeSrc}"
            width="400"
            height="700"
            style="border:none;overflow:hidden;background:black;"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            title="Brat and Judy episode video"></iframe>
        </div>
        <a href="${fbUrl}" target="_blank" rel="noopener" class="bj-fb-modal-link">
          Trouble seeing it? Open on Facebook →
        </a>
      </div>
    `;
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    // Animate in
    requestAnimationFrame(function() {
      modal.classList.add('is-visible');
    });

    // Close handlers
    function closeModal() {
      modal.classList.remove('is-visible');
      document.body.style.overflow = '';
      setTimeout(function() { modal.remove(); }, 300);
      document.removeEventListener('keydown', escHandler);
    }
    function escHandler(e) {
      if (e.key === 'Escape') closeModal();
    }

    modal.querySelector('.bj-fb-modal-close').addEventListener('click', closeModal);
    modal.querySelector('.bj-fb-modal-backdrop').addEventListener('click', closeModal);
    document.addEventListener('keydown', escHandler);
  }

  function replaceCardWithVideo(card) {
    const videoEl = card.querySelector('.episode-video');
    if (!videoEl) return;

    const videoUrl = videoEl.dataset.videoUrl;
    const fbUrl = videoEl.dataset.fbUrl;
    const thumb = card.querySelector('.episode-thumb');
    if (!thumb) return;

    // ===== PRIORITY 1: FACEBOOK EMBED =====
    // If an FB URL is provided, embed FB's video player.
    // Plays counted here go toward the FB video's view count
    // (talent monetization stays intact) AND the viewer never
    // has to leave the KHP landing page.
    if (fbUrl) {
      // Facebook's Reel plugin embeds are unreliable inline (controls hide,
      // autoplay requires FB sign-in, etc). We use a modal lightbox pattern:
      // click play → opens a fixed-size portrait modal with the FB iframe.
      // Fixed pixel dimensions render more reliably than responsive sizing.

      // Read thumbnail URL from the video element's data attribute.
      // If no thumbnail is uploaded, we generate a chrome-pink themed card
      // with the episode number and title (see .episode-thumb-generated).
      const thumbnailUrl = videoEl.dataset.thumbnail || '';
      const hasThumbnail = thumbnailUrl.length > 0;

      // Preserve the generated-thumb markup if that's what we're working with
      // so the auto-generated design stays visible under the play button
      const generatedThumb = card.querySelector('.episode-thumb-generated');
      let posterHTML = '';
      let posterStyle = '';

      if (hasThumbnail) {
        posterStyle = `background-image: url("${thumbnailUrl}") !important; background-size: cover !important; background-position: center !important;`;
      } else if (generatedThumb) {
        // Clone the generated-card content into the poster so it still shows
        posterHTML = generatedThumb.innerHTML;
      }

      thumb.innerHTML = `
        <div class="bj-fb-embed" data-fb-url="${fbUrl}">
          <div class="bj-fb-poster ${!hasThumbnail && generatedThumb ? 'bj-fb-poster-generated' : ''}"
               ${!hasThumbnail && generatedThumb ? 'data-variant="' + generatedThumb.dataset.variant + '"' : ''}
               style="${posterStyle}">
            ${posterHTML}
            <button type="button" class="bj-fb-play-btn" aria-label="Play video">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4l14 8-14 8V4z" fill="currentColor"/>
              </svg>
            </button>
            <div class="bj-fb-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z"/>
              </svg>
              <span>Watch on Facebook</span>
            </div>
          </div>
        </div>
      `;
      // Clear the thumb's own background so the poster shows through
      thumb.style.background = 'transparent';
      thumb.style.backgroundImage = 'none';

      // Bind click-to-open-modal
      const playBtn = thumb.querySelector('.bj-fb-play-btn');
      if (playBtn) {
        playBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          openFBModal(fbUrl);
        });
      }
    }
    // ===== PRIORITY 2: SELF-HOSTED MP4 (fallback) =====
    else if (videoUrl) {
      thumb.innerHTML = `
        <div class="bj-video-wrap">
          <video
            class="bj-video"
            playsinline
            preload="metadata"
            disablePictureInPicture>
            <source src="${videoUrl}" type="video/mp4">
            Your browser does not support video.
          </video>

          <button type="button" class="bj-play-overlay" aria-label="Play video">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 4l14 8-14 8V4z" fill="currentColor"/>
            </svg>
          </button>

          <div class="bj-loader" aria-hidden="true">
            <div class="bj-loader-heart">♥</div>
          </div>

          <div class="bj-controls">
            <button type="button" class="bj-ctrl bj-play-btn" aria-label="Play/Pause">
              <svg class="bj-icon-play" viewBox="0 0 24 24" fill="none">
                <path d="M6 4l14 8-14 8V4z" fill="currentColor"/>
              </svg>
              <svg class="bj-icon-pause" viewBox="0 0 24 24" fill="none">
                <rect x="6" y="4" width="4" height="16" fill="currentColor"/>
                <rect x="14" y="4" width="4" height="16" fill="currentColor"/>
              </svg>
            </button>

            <span class="bj-time bj-time-current">0:00</span>

            <div class="bj-scrubber">
              <div class="bj-scrubber-track">
                <div class="bj-scrubber-buffered"></div>
                <div class="bj-scrubber-progress">
                  <div class="bj-scrubber-thumb"></div>
                </div>
              </div>
              <input type="range" class="bj-scrubber-input" min="0" max="100" value="0" step="0.1" aria-label="Video progress">
            </div>

            <span class="bj-time bj-time-total">0:00</span>

            <button type="button" class="bj-ctrl bj-mute-btn" aria-label="Mute/Unmute">
              <svg class="bj-icon-volume" viewBox="0 0 24 24" fill="none">
                <path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/>
                <path d="M15.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" fill="currentColor"/>
              </svg>
              <svg class="bj-icon-muted" viewBox="0 0 24 24" fill="none">
                <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 4v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.17v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" fill="currentColor"/>
              </svg>
            </button>

            <button type="button" class="bj-ctrl bj-fs-btn" aria-label="Toggle fullscreen">
              <svg class="bj-icon-fs-enter" viewBox="0 0 24 24" fill="none">
                <path d="M4 9V4H9M20 9V4H15M4 15V20H9M20 15V20H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="bj-icon-fs-exit" viewBox="0 0 24 24" fill="none">
                <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      `;
      thumb.style.background = 'black';

      const wrap = thumb.querySelector('.bj-video-wrap');
      const video = thumb.querySelector('.bj-video');
      bindCustomPlayer(wrap, video);
    }
    // ===== PRIORITY 3: NO URLS =====
    else {
      thumb.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:center;width:100%;height:100%;flex-direction:column;gap:10px;padding:20px;text-align:center;color:rgba(255,244,250,0.7);background:linear-gradient(160deg, var(--brand-pink), var(--brand-purple) 60%, var(--deep-plum));">
          <span style="font-size:36px;">♥</span>
          <span style="font-family:'Lilita One',cursive;font-size:16px;letter-spacing:0.04em;">Episode Coming Soon</span>
          <span style="font-size:11px;letter-spacing:0.18em;text-transform:uppercase;opacity:0.7;">Check back soon</span>
        </div>
      `;
    }
  }

  function initEmailForm() {
    const form = document.getElementById('bjEmailForm');
    if (!form) return;

    const submitBtn = document.getElementById('bjEmailSubmit');
    const emailInput = document.getElementById('bjEmailInput');
    const errorEl = document.getElementById('bjEmailError');

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = emailInput.value.trim();

      // Basic email validation
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showEmailError('Please enter a valid email address.');
        return;
      }

      hideEmailError();
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
      emailInput.disabled = true;

      // Submit to Shopify's contact endpoint via FormData
      // This creates a customer with the tag "brat-judy-krewe"
      // for Klaviyo sync, while we control the UI ourselves.
      const formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('contact[email]', email);
      formData.append('contact[accepts_marketing]', 'true');
      formData.append('contact[tags]', 'brat-judy-krewe');

      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html' }
      })
      .then(function(res) {
        // Shopify returns 200 with a redirect HTML body on success,
        // or 422 with errors. Either way, if we got a response,
        // the email was captured.
        return res.text().then(function(body) {
          return { status: res.status, body: body };
        });
      })
      .then(function(result) {
        // Shopify's customer endpoint is forgiving — even duplicate
        // emails return a successful redirect. We treat any 2xx
        // or 3xx-ish response as success for the unlock flow.
        if (result.status >= 200 && result.status < 400) {
          handleEmailSuccess();
        } else if (result.body && result.body.indexOf('has already been taken') !== -1) {
          // Existing customer — that's fine, unlock anyway
          handleEmailSuccess();
        } else {
          // Some unexpected error
          handleEmailSuccess(); // Fail-open: unlock anyway so user isn't blocked
        }
      })
      .catch(function(err) {
        console.warn('BJ email signup error (failing open):', err);
        // Network error — still unlock so the user has a good experience.
        // Their email will need to be captured separately.
        handleEmailSuccess();
      });
    });

    function handleEmailSuccess() {
      submitBtn.classList.remove('is-loading');
      submitBtn.classList.add('is-success');
      localStorage.setItem('bj_unlocked', 'true');
      // Wait a beat so they see the "You're In" state, then unlock
      setTimeout(function() {
        unlockEpisodes(false);
      }, 800);
    }

    function showEmailError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function hideEmailError() {
      if (!errorEl) return;
      errorEl.hidden = true;
    }

    // If a Klaviyo form is on the page, listen for its success event
    document.addEventListener('klaviyoForms', function(e) {
      if (e.detail && e.detail.type === 'submit') {
        unlockEpisodes(false);
      }
    });
  }

  // ===== COUNTDOWN TIMER =====
  function initCountdown() {
    const countdown = document.querySelector('.limited-countdown');
    if (!countdown) return;

    const endDateStr = countdown.dataset.endDate;
    if (!endDateStr) return;

    // Parse "YYYY-MM-DD HH:MM" as local time
    const endDate = new Date(endDateStr.replace(' ', 'T'));
    if (isNaN(endDate.getTime())) {
      console.warn('BJ: Invalid countdown end date:', endDateStr);
      return;
    }

    const daysEl = countdown.querySelector('[data-cd="days"]');
    const hoursEl = countdown.querySelector('[data-cd="hours"]');
    const minsEl = countdown.querySelector('[data-cd="mins"]');
    const secsEl = countdown.querySelector('[data-cd="secs"]');

    function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

    function tick() {
      const now = new Date();
      const diff = endDate - now;

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        // Optionally hide the countdown or swap to "Ended"
        const label = countdown.querySelector('.countdown-label');
        if (label) label.textContent = 'This drop has ended';
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  // ===== AJAX ADD TO CART =====
  function addToCart(variantId, quantity, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }]
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function(data) {
      // Refresh cart count if theme exposes it
      updateCartCount();
      if (callback) callback(null, data);
    })
    .catch(function(err) {
      if (callback) callback(err);
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        // Common cart count selectors used across Shopify themes
        const selectors = [
          '.cart-count',
          '.cart-count-bubble',
          '[data-cart-count]',
          '.site-header__cart-count',
          '.header__cart-count'
        ];
        selectors.forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(el) {
            el.textContent = cart.item_count;
            el.classList.remove('hidden');
          });
        });
      })
      .catch(function() {});
  }

  function showCartToast(productName, productImage) {
    // Remove any existing toast
    const existing = document.querySelector('.bj-cart-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'bj-cart-toast';
    toast.innerHTML = `
      <span class="toast-icon">♥</span>
      <div class="toast-text">
        <strong>Added to cart</strong>
        ${productName}
      </div>
      <a href="/cart" class="toast-link">View Cart →</a>
    `;
    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    // Auto-dismiss after 4 seconds
    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() { toast.remove(); }, 500);
    }, 4000);
  }

  function handleFaveSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const btn = form.querySelector('.js-fave-add');
    const variantInput = form.querySelector('.js-fave-variant');
    const variantId = variantInput.value;
    const productName = form.closest('.fave-card').querySelector('.fave-title').textContent.trim();

    if (!variantId || btn.disabled) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    addToCart(variantId, 1, function(err) {
      btn.classList.remove('is-loading');
      if (err) {
        btn.disabled = false;
        alert('Sorry, we couldn\'t add this to your cart. Please try again.');
        return;
      }
      btn.classList.add('is-success');
      showCartToast(productName);
      setTimeout(function() {
        btn.classList.remove('is-success');
        btn.disabled = false;
      }, 2200);
    });
  }

  function handleLimitedSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const btn = form.querySelector('.js-limited-add');
    const variantInput = form.querySelector('.js-limited-variant');
    const variantId = variantInput.value;
    const productName = document.querySelector('.limited-name')?.textContent.trim() || 'Bundle';

    if (!variantId || btn.disabled) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    addToCart(variantId, 1, function(err) {
      btn.classList.remove('is-loading');
      if (err) {
        btn.disabled = false;
        alert('Sorry, we couldn\'t add this to your cart. Please try again.');
        return;
      }
      btn.classList.add('is-success');
      showCartToast(productName);
      setTimeout(function() {
        btn.classList.remove('is-success');
        btn.disabled = false;
      }, 2200);
    });
  }

  function initAjaxCart() {
    document.querySelectorAll('.js-fave-form').forEach(function(form) {
      form.addEventListener('submit', handleFaveSubmit);
    });
    document.querySelectorAll('.js-limited-form').forEach(function(form) {
      form.addEventListener('submit', handleLimitedSubmit);
    });
  }

  // ===== EPISODE PAGINATION + SEARCH =====
  function initEpisodePagination() {
    const section = document.getElementById('bj-episodes');
    if (!section) return;

    const grid = document.getElementById('bjEpisodeGrid');
    const loadMoreBtn = document.getElementById('bjLoadMore');
    const showAllBtn = document.getElementById('bjShowAll');
    const searchInput = document.getElementById('bjEpisodeSearch');
    const clearSearchBtn = document.getElementById('bjClearSearch');
    const emptyState = document.getElementById('bjEpisodesEmpty');
    const loadedCountEl = document.getElementById('bjLoadedCount');
    const countNumEl = document.getElementById('bjEpisodeCount');

    if (!grid) return;

    const perPage = parseInt(section.dataset.perPage, 10) || 6;
    const totalEpisodes = parseInt(section.dataset.total, 10) || 0;
    const allCards = Array.from(grid.querySelectorAll('.episode-card'));

    let visibleCount = perPage;
    let searchQuery = '';

    function applyVisibility() {
      let shownCount = 0;
      let matchingCount = 0;

      allCards.forEach(function(card) {
        const title = card.dataset.title || '';
        const epNum = card.dataset.episode || '';
        const matchesSearch = searchQuery === '' ||
                              title.indexOf(searchQuery) !== -1 ||
                              epNum.indexOf(searchQuery) !== -1;

        if (matchesSearch) {
          matchingCount++;
          if (shownCount < visibleCount) {
            card.classList.remove('is-hidden');
            shownCount++;
          } else {
            card.classList.add('is-hidden');
          }
        } else {
          card.classList.add('is-hidden');
        }
      });

      // Update count display
      if (countNumEl) {
        countNumEl.textContent = searchQuery ? matchingCount : totalEpisodes;
      }
      if (loadedCountEl) {
        loadedCountEl.textContent = Math.min(shownCount, matchingCount);
      }

      // Toggle empty state (only when searching)
      if (emptyState) {
        if (searchQuery && matchingCount === 0) {
          emptyState.hidden = false;
          grid.classList.add('is-empty');
        } else {
          emptyState.hidden = true;
          grid.classList.remove('is-empty');
        }
      }

      // Toggle Load More button visibility
      if (loadMoreBtn) {
        if (shownCount >= matchingCount || matchingCount === 0) {
          loadMoreBtn.classList.add('is-hidden');
        } else {
          loadMoreBtn.classList.remove('is-hidden');
        }
      }

      // Show All button hides when everything is already shown or during search
      if (showAllBtn) {
        if (searchQuery || visibleCount >= totalEpisodes) {
          showAllBtn.classList.add('is-hidden');
        } else {
          showAllBtn.classList.remove('is-hidden');
        }
      }
    }

    // Load More: reveal next batch
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function() {
        visibleCount = Math.min(visibleCount + perPage, allCards.length);
        applyVisibility();
      });
    }

    // Show All: reveal everything
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function() {
        visibleCount = allCards.length;
        applyVisibility();
      });
    }

    // Search input
    if (searchInput) {
      let searchDebounce;
      searchInput.addEventListener('input', function() {
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(function() {
          searchQuery = searchInput.value.trim().toLowerCase();
          // Reset visible count when searching so results show from top
          if (searchQuery) {
            visibleCount = allCards.length;
          } else {
            visibleCount = perPage;
          }
          applyVisibility();
        }, 200);
      });
    }

    // Clear search from empty state
    if (clearSearchBtn && searchInput) {
      clearSearchBtn.addEventListener('click', function() {
        searchInput.value = '';
        searchQuery = '';
        visibleCount = perPage;
        applyVisibility();
        searchInput.focus();
      });
    }

    // Initial state
    applyVisibility();
  }

  // ===== INIT =====
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHeartField();
      initEmailForm();
      checkExistingUnlock();
      initCountdown();
      initAjaxCart();
      initEpisodePagination();
    });
  } else {
    initHeartField();
    initEmailForm();
    checkExistingUnlock();
    initCountdown();
    initAjaxCart();
    initEpisodePagination();
  }
})();